import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { ClientService } from '../../../../services/clients';
import { UserService } from '../../../../services/user';

@Component({
  selector: 'app-createclient',
  templateUrl: './createclient.component.html',
  styleUrls: ['./createclient.component.scss']
})
export class CreateclientComponent implements OnInit {

  data!: FormGroup;
  dataForm: FormData = new FormData();
  contentReady: boolean = false;
  isMobile: boolean = false;
  isAr: boolean = false;
  editId!: any;
  isUpdatePage: boolean = false;
  systemAccess: boolean = false;
  type: string = 'text';
  accounttype!: any;
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;

  constructor(
    private fb: FormBuilder,
    private _clients: ClientService,
    private router: Router,
    private _userService: UserService,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService
  ) { }

  ngOnInit(): void {
    this.checkAccountType();
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") === "ar";
    this.contentReady = true;
    this.initForm();
  

    this.route.queryParams.subscribe(params => {
      if (params["id"]) {
        this.isUpdatePage = true;
        this.editId = params["id"];
        // ✨ املا النموذج من params
        this.data.patchValue({
          name_en: params["name_en"] || '',
          name_ar: params["name_ar"] || '',
          job: params["job"] || '',
          address: params["address"] || '',
          phone_number: params["phone_number"] || '',
          another_phone: params["another_phone"] || '',
          internet_date: params["internet_date"] || '',
          request_number: params["request_number"] || '',
          visa_number: params["visa_number"] || '',
          record_number: params["record_number"] || '',
          passport_number: params["passport_number"] || '',
          lab: params["lab"] == '1', // ✅ نحول من string إلى boolean
          hospital: params["hospital"] == '1',
          fingerprint: params["fingerprint"] == '1',
          contract: params["contract"] == '1',
          authorization: params["authorization"] == '1',
          foreign_agency: params["foreign_agency"] || '',
          follow_up: params["follow_up"] == '1',
          follow_up_statement: params["follow_up_statement"] == '1',
          execution: params["execution"] == '1',
          worker_embassy: params["worker_embassy"] || '',
          notes: params["notes"] || '',
          status: params["status"] || 0,
          paid: params["paid"] || 0,
          remaining: params["remaining"] || 0,
          representative: params["representative"] || '',
          payment_method: params["payment_method"] || 0, // 0=cash,1=visa,2=wallet,3=instapay
          visa_type: params["visa_type"] || 0,          // 0=normal,1=express
          payment_status: params["payment_status"] || 0 // 0=unpaid,1=partial,2=paid,3=refunded
        });
      }
    });


  }
  checkAccountType() {
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accounttype = data['user_type'];

        console.log(this.accounttype)
      },
      error: (error) => console.error(error),
    });
    return this.accounttype;
  }
  initForm() {
    this.data = this.fb.group({
      name_en: ['', Validators.required],
      name_ar: [''],
      job: ['', Validators.required],
      address: [''],
      phone_number: ['', Validators.required],
      another_phone: [''],
      internet_date: [''],
      request_number: [''],
      visa_number: [''],
      record_number: [''],
      passport_number: [''],
      lab: [false],
      hospital: [false],
      fingerprint: [false],
      contract: [false],
      authorization: [false],
      foreign_agency: [''],
      follow_up: [false],
      follow_up_statement: [false],
      execution: [false],
       add_by: [localStorage.getItem("username")],
      notes: [''],
      status: [0],
      worker_embassy: [''],

      // ✅ الحقول الجديدة
      paid: [, [Validators.min(0)]],
      remaining: [, [Validators.min(0)]],
      representative: [''],
      payment_method: [0, Validators.required],  // 0=cash,1=visa,2=wallet,3=instapay
      visa_type: ['0', Validators.required],       // 0=normal,1=express
      payment_status: [0, Validators.required]   // 0=unpaid,1=partial,2=paid,3=refunded
    });
  }


  appendPostDtata() {
    this.dataForm = new FormData();

    Object.entries(this.data.value).forEach(([key, value]) => {
      // لو القيمة Boolean، نحولها لقيمة مناسبة
      if (typeof value === 'boolean') {
        this.dataForm.append(key, value ? '1' : '0'); // Laravel بيفضل 1 و 0 في boolean
      } else if (value !== null && value !== undefined) {
        this.dataForm.append(key, value.toString());
      }
    });

  }



  onSubmit() {
    this.appendPostDtata();

    if (this.isUpdatePage) {
      this.onEdit();
    } else {
      this.onAdd();
    }
  }

  onAdd() {
    this.contentReady = true;
    this._clients.create(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم إنشاء العميل" : 'Client created',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
        const redirectUrl = '/myclients';
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل إنشاء العميل" : 'Client not created',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });

        this.contentReady = false;
      }
    });
  }

  onEdit() {
    this.contentReady = true;
             const username = localStorage.getItem("username") || "Unknown";
  this.dataForm.append('editor', username);
    this._clients.update(this.editId, this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل العميل" : 'Client updated',
          showConfirmButton: false,
          timer: 1500,
        });

        this.contentReady = false;
        const redirectUrl = '/myclients';
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل تعديل العميل" : 'Client not updated',
          confirmButtonText: this.isAr ? 'تمام' : 'OK',
        });

        this.contentReady = false;
      }
    });
  }





}
